import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgName = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "#323338",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Group_6068",
		"data-name": "Group 6068",
		transform: "translate(-2 -2)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Path_8563",
			"data-name": "Path 8563",
			d: "M20,7H15V4a2.006,2.006,0,0,0-2-2H11A2.006,2.006,0,0,0,9,4V7H4A2.006,2.006,0,0,0,2,9V20a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V9A2.006,2.006,0,0,0,20,7ZM9,12a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,9,12Zm3,6H6v-.43a1.516,1.516,0,0,1,.92-1.39,5.246,5.246,0,0,1,4.16,0A1.522,1.522,0,0,1,12,17.57Zm1-9H11V4h2Zm4.25,7.5h-2.5a.755.755,0,0,1-.75-.75h0a.755.755,0,0,1,.75-.75h2.5a.755.755,0,0,1,.75.75h0A.755.755,0,0,1,17.25,16.5Zm0-3h-2.5a.755.755,0,0,1-.75-.75h0a.755.755,0,0,1,.75-.75h2.5a.755.755,0,0,1,.75.75h0A.755.755,0,0,1,17.25,13.5Z"
		})
	})
});
export { SvgName as ReactComponent };
